import React from 'react';

const steps = [
  {
    number: '01',
    title: 'Sign Up & Set Up',
    description:
      'Create your account, set your company details, and invite your team in under 2 minutes.',
    videoBase: '/videos/step-signup',
  },
  {
    number: '02',
    title: 'Add Your Fleet',
    description:
      'Import or add your drivers and vehicles. CDL tracking, maintenance schedules — it\'s all here.',
    videoBase: '/videos/step-fleet',
  },
  {
    number: '03',
    title: 'Dispatch & Track',
    description:
      'Assign loads, track deliveries in real-time, and get notified at every milestone.',
    videoBase: '/videos/step-dispatch',
  },
];

function StepCard({ number, title, description, videoBase }) {
  return (
    <div className="flex flex-col items-center text-center">
      <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-600 to-cyan-500 flex items-center justify-center shadow-lg">
        <span className="text-white font-bold text-xl font-mono">{number}</span>
      </div>

      <h3 className="text-xl font-semibold text-gray-900 mt-4 mb-2">{title}</h3>
      <p className="text-gray-500 text-sm mb-6">{description}</p>

      <div className="w-full bg-gray-900 rounded-xl overflow-hidden shadow-lg border border-gray-800">
        {/* Fake browser toolbar */}
        <div className="h-10 bg-gray-800 flex items-center px-4 gap-3">
          <div className="flex items-center gap-1.5">
            <span className="w-3 h-3 rounded-full bg-red-500 block" />
            <span className="w-3 h-3 rounded-full bg-yellow-400 block" />
            <span className="w-3 h-3 rounded-full bg-green-500 block" />
          </div>
          <div className="flex-1 bg-gray-700 rounded-md h-5" />
        </div>

        {/* Video */}
        <video
          className="w-full"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={`${videoBase}.webm`} type="video/webm" />
          <source src={`${videoBase}.mp4`} type="video/mp4" />
        </video>
      </div>
    </div>
  );
}

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-gray-50 py-24">
      <div className="max-w-6xl mx-auto px-6">
        {/* Eyebrow */}
        <p className="text-center text-blue-600 text-xs font-bold uppercase tracking-widest mb-3">
          How It Works
        </p>

        {/* Heading */}
        <h2 className="text-center text-3xl md:text-4xl font-bold text-gray-900 mb-16">
          Up and Running in Minutes
        </h2>

        {/* Steps grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {steps.map((step) => (
            <StepCard key={step.number} {...step} />
          ))}
        </div>
      </div>
    </section>
  );
}
